import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import Participant from './participant';
import Invitation from './invitation';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const slash = '/';
export const RequestWorkflowView = props => {
  const workflowSize = props.workflow.length;
  const isWorkflowEnded = props.signingStep === workflowSize;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("h2", {
      children: [/*#__PURE__*/_jsx(Translate, {
        value: "request.page.participants"
      }), /*#__PURE__*/_jsx("span", {
        className: "separator"
      }), /*#__PURE__*/_jsx("span", {
        className: !props.loading && !props.error && isWorkflowEnded ? 'success' : 'error',
        children: /*#__PURE__*/_jsxs("strong", {
          children: [props.signingStep, slash, workflowSize]
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "card flex-container column",
      children: props.error ? /*#__PURE__*/_jsx("span", {
        "data-id": "error-message",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "error.generic"
        })
      }) : props.loading ? /*#__PURE__*/_jsx("div", {
        className: "loading-overlay"
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: props.workflow.map((step, index, workflow) => {
          const participant = props.participants.find(participant => participant.id === step[0].organisationId);
          const suspensiveCondition = props.suspensiveConditions?.find(condition => condition.organisationRole === step[0].role);
          const isFinalCondition = workflow[workflow.length - 1][0].role === suspensiveCondition?.organisationRole;
          return participant ? /*#__PURE__*/_jsx(Participant, {
            organisationId: props.organisationId,
            actionUsers: props.actionUsers,
            participant: participant,
            userRoles: props.userRoles,
            suspensiveCondition: suspensiveCondition,
            stepTasks: step,
            position: index + 1,
            isLast: workflow.length - 1 === index,
            isFinalCondition: isFinalCondition,
            isWorkflowEnded: isWorkflowEnded,
            onSignClick: props.onSignClick,
            onVerifyClick: props.onVerifyClick,
            onRejectRequestClick: props.onRejectRequestClick,
            onRemoveConditionClick: props.onRemoveConditionClick
          }, index) : props.invitations.length > 0 ? /*#__PURE__*/_jsx(Invitation, {
            invitation: props.invitations.find(invite => step[0].role === invite.role),
            position: index + 1
          }, index) : null;
        })
      })
    })]
  });
};
RequestWorkflowView.defaultProps = {
  loading: false,
  error: false
};
RequestWorkflowView.propTypes = {
  organisationId: PropTypes.number.isRequired,
  workflow: PropTypes.array.isRequired,
  signingStep: PropTypes.number.isRequired,
  participants: PropTypes.array.isRequired,
  actionUsers: PropTypes.array.isRequired,
  invitations: PropTypes.array.isRequired,
  userRoles: PropTypes.array.isRequired,
  suspensiveConditions: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onSignClick: PropTypes.func.isRequired,
  onVerifyClick: PropTypes.func.isRequired,
  onRejectRequestClick: PropTypes.func.isRequired,
  onRemoveConditionClick: PropTypes.func.isRequired
};
export default RequestWorkflowView;